<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>

    <div v-if="this.$route.meta.Navbar === true">
      <navbar></navbar>
      <div class="pt-4"></div>
    </div>

    <div class="container-fluid p-none">
      <keep-alive include="account">
        <router-view></router-view>
      </keep-alive>
    </div>

    <div class="sticky-footer-spacing"></div>

    <div v-if="this.$route.meta.Footer === true">
      <app-footer></app-footer>
    </div>

    <v-dialog/>
  </div>
</template>

<script>
import Navbar from './components/Partials/Navbar.vue'
import Footer from './components/Partials/Footer.vue'

export default {
  components: {
    navbar: Navbar,
    appFooter: Footer
  }
}
</script>

<style>
  @import 'https://cdn.jsdelivr.net/fontawesome/4.7.0/css/font-awesome.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue